import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import useAxiosHook from '../../../../../../../hooks/useAxiosHook';
import useToastMessage from '../../../../../../../hooks/useToastMessage';
import { Numeric } from '../../../../../../../types/general';
import { sequential } from '../../../../../../../utils/helpers/functions';

type Props = {
  visible: boolean;
  onHide: () => void;
  onSuccess: () => void;
  receptionId: number | undefined;
  shipmentCount: Numeric;
};

function SaveDialog({
  visible,
  onHide,
  onSuccess,
  receptionId,
  shipmentCount,
}: Props): JSX.Element {
  const { t } = useTranslation();

  const { data, error, isLoading, reload } = useAxiosHook();

  useToastMessage(data, error, {
    success: {
      summary: t('Reception successfully finalized!'),
      callback: () => sequential(onHide, onSuccess),
    },
    error: {
      summary: t('An error occured while finalizing reception.'),
    },
  });

  function onDiscardBtnClick() {
    reload({
      url: `/customer-receptions/${receptionId}`,
      method: 'PUT',
    });
  }

  const dialogFooter = (
    <>
      <Button
        type="button"
        label={t('Close')}
        onClick={onHide}
        className="p-button-text"
      />

      <Button
        type="button"
        label={isLoading ? t('Saving...') : t('Save')}
        disabled={isLoading}
        onClick={onDiscardBtnClick}
      />
    </>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('Finalize reception?')}
      footer={dialogFooter}
    >
      {t(
        'Are you sure you want to finalize the current reception with a total of {{shipmentCount}} shipment(s)?',
        {
          shipmentCount,
        }
      )}
    </Dialog>
  );
}

export default SaveDialog;
